import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "leaflet/dist/leaflet.css";
import { fixLeafletMarkerImageLoading } from './common/utils';
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

fixLeafletMarkerImageLoading();

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);
// disable google page trasnlation
document.getElementById("root")!.setAttribute("translate", "no");

root.render(
    <React.StrictMode>
        <App />
    </React.StrictMode>
);
